
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { WxPhoneX } from '@tencent/wphk-act-base-ui';
import { FitIcon } from '@tencent/wphk-ui';
import '@tencent/bk-icon-wphk-ui';
import { initLang, i18n } from './i18n';
import { language } from '@tencent/ppd-base-libs';

@Component({
  components: {
    WxPhoneX,
    FitIcon,
  },
})
export default class Tnc extends Vue {
  i18n = i18n;
  /** tnc信息 */
  @Prop() title?: string;
  /** tnc文字及icon颜色 */
  @Prop({ default: '#ffffff' }) color!: string;
  // biExt
  fbusiness = localStorage.getItem('fbusiness');
  created() {
    // 获取指定语言
    initLang(language.getLanguage());
  }

  /** 点击跳转 */
  @Emit('toTnc')
  public toTnc() {}
}
